import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Tab from "../components/tab";
import {
  personal_information,
  save_secret,
  returnHome,
} from "../../../Redux/ActionCreator";
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";

export default function PersonalInfoPage1({ nextStep, prevStep }) {
  const dispatch = useDispatch();
  
  const info = useSelector((info) => info.personal_info);
  const secret = useSelector((prev) => prev.secret);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);


  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showFirstName, setShowFirstName] = useState(false);
  const [showLastName, setShowLastName] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    // if (secret.secret === null && (existingResume.message !== null && existingResume.message?.Secret == null)) {
    //   const clientSecret = uuidv4();
    //   dispatch(save_secret(clientSecret));
    // } else {
    //   dispatch(save_secret(existingResume.message?.Secret))
    // }

    if (secret.secret === null) {
      const clientSecret = uuidv4();
      dispatch(save_secret(clientSecret));
    }
  }, []);

  useEffect(() => {
    if (info.message !== null) {
      // get the first and lastname only
      setFirstName(info.message?.Firstname !== undefined ? info.message?.Firstname : "");
      setLastName(info.message?.LastName !== undefined ? info.message?.LastName : "");
    } else {
      let cacheInfo = getOneFromServerCache("personalInfo")
      cacheInfo.then(res => res.json())
        .then(res => {
          console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(personal_information(resObj));
              setFirstName(resObj?.Firstname);
              setLastName(resObj?.LastName);
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch(err => {
          // console.log("Error getting personal info", err)
        })
    }
  }, []);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const firstNameTimeout = setTimeout(() => setShowFirstName(true), 2500); // Matches Typewriter speed

    return () => clearTimeout(firstNameTimeout);
  }, []);

  useEffect(() => {
    if (firstName?.length > 0 && showFirstName == true) {
      // Show last name label and input once first name is being typed
      const lastNameTimeout = setTimeout(() => setShowLastName(true), 500);
      return () => clearTimeout(lastNameTimeout);
    }
  }, [firstName, showFirstName]); // Runs only when firstName updates

  
  useEffect(() => {
    if (lastName !== "" && showLastName == true) {
      // Show last name label and input once first name is being typed
      const buttomTimeout = setTimeout(() => setShowButtomBTN(true), 500);
      return () => clearTimeout(buttomTimeout);
    }
  }, [lastName, showLastName]); // Runs only when firstName updates

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (firstName !== "" && lastName !== "") {
        let names = {
          Firstname: capitalize(firstName)?.trim(),
          LastName: capitalize(lastName),
          Address: info.message?.Address,
          Phone_number: info.message?.Phone_number,
          Email: info.message?.Email,
          JobInterests: info.message?.JobInterests
        }
        dispatch(personal_information(names));
        // save into server cache
        await saveIntoServerCache("personalInfo", names);
        nextStep();
      } else {
          setTimeout(() => {
              toast.error("Fullname and lastname is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
          }, 50);
      }
    } catch (error) {
        throw error
    }
  }
  /* Monving setion ends */

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"}  vsm:w-[90vw] gap-y-16 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md p-6 md:p-8`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-x-hidden">
            <Tab label="Personal Information" current={true} completed={false} num="1" />
            <Tab num="2" current={false} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Input Section with Typewriter Effect and Fade-in Inputs */}
        <div className="flex justify-center">
          <div className="flex flex-col gap-y-6 items-center w-[100vw] lg:max-w-[90%] justify-center">
            
            {/* First message with Typewriter */}
            <motion.p 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut" }} 
              className="text-xl lg:text-2xl text-[#5843BD] font-semibold notranslate"
            >
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Primero, dinos tu nombre."]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter  key={flowLanguage}  words={["First, tell us your name."]} loop={1} typeSpeed={40} />
              )}
            </motion.p>

            <div className="flex lg:w-full zsm:w-[400px] flex-col lg:flex-row md:gap-8 md:justify-between justify-center">
              
              {/* First Name Input with Animation */}
              {showFirstName && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                  className={`flex w-full flex-col gap-y-2 vsm:my-6 md:my-0`}
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="firstName" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿Cuál es tu nombre?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What's your first name?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What's your first name?"]} loop={1} /> */}
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        className="w-full md:max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        placeholder="First name here"
                      />
                    </div>
                  </div>
                </motion.div>
              )}

              {/* Last Name Input with Animation */}
              {showLastName && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                  className="flex w-full flex-col gap-y-2"
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="lastName" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿Cuál es tu apellido?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What is your last name?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What is your last name?"]} loop={1} /> */}
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        className="w-full border-2 max-w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        placeholder="Last name here"
                      />
                    </div>
                  </div>
                </motion.div>
              )}
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-8 rounded-md notranslate" key={flowLanguage}
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {flowLanguage == "Spanish" ? (
                        "ANTERIOR"
                      ) : (
                        "PREVIOUS"
                      )}
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md notranslate" key={flowLanguage}
                  >
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>
        

      </div>
      <ToastContainer />
    </div>
  );
}
